// src/routes/ProtectedRoutes.tsx
import React from 'react';
import { Layout } from 'antd';

import { Path } from '../constants/Path';
import ProtectedRoute from '../components/ProtectedRoute';
import ActiveListGuard from '../components/ActiveListGuard';
import DefaultLayout from '../layouts/DefaultLayout';
import WordsListsView from '../views/words-lists';
import StudentWordsListsView from '../views/student-words-list';
import TermsAndConditionsView from '../views/terms-and-conditions';
import PrivacyPolicyView from '../views/privacy-policy';
import ContactView from '../views/contact';
import StudentListView from '../views/student/StudentListView';
import WordsListView from '../views/words-list';
import RepeatView from '../views/repeat';
import FindView from '../views/find';
import MemoryView from '../views/memory';
import WritingView from '../views/writing';
import RecognizeView from '../views/recognize';
import RecognizeView2 from '../views/recognize2';
import PickView from '../views/pick';
import PairingView from '../views/pairing';
import LettersView from '../views/letters';
import CatalogEntriesView from '../views/catalog';
import KiddoRepeatView from '../views/kiddo-games/repeat';
import KiddoFindView from '../views/kiddo-games/find';
import KiddoPickView from '../views/kiddo-games/pick';
import KiddoPairingView from '../views/kiddo-games/pairing';
import KiddoMemoryView from '../views/kiddo-games/memory';
import KiddoRecognizeView from '../views/kiddo-games/recognize';
import KiddoRecognizeView2 from '../views/kiddo-games/recognize2';
import KiddoDragLettersView from '../views/kiddo-games/drag-letters';
import KiddoWritingView from '../views/kiddo-games/writing';
import KiddoLettersView from '../views/kiddo-games/letters';

const {
  MY_LISTS,
  WORDS_LIST,
  WORDS_LIST_ITEM,
  CATALOG,
  STUDENTS,
  PROFILE,
  LETTERS,
  REPEAT,
  MEMORY,
  FIND,
  PICK,
  PAIRING,
  RECOGNIZE,
  RECOGNIZE2,
  WRITING,
  KIDDO_REPEAT,
  KIDDO_FIND,
  KIDDO_PICK,
  KIDDO_PAIRING,
  KIDDO_MEMORY,
  KIDDO_RECOGNIZE,
  KIDDO_RECOGNIZE2,
  KIDDO_DRAGLETTERS,
  KIDDO_WRITING,
  KIDDO_LETTERS,
  PRIVACY_POLICY,
  TERMS_AND_CONDITIONS,
  CONTACT,
} = Path;

const gameRoutes = [
  LETTERS,
  REPEAT,
  FIND,
  PICK,
  MEMORY,
  PAIRING,
  RECOGNIZE,
  RECOGNIZE2,
  WRITING,
  KIDDO_REPEAT,
  KIDDO_FIND,
  KIDDO_PICK,
  KIDDO_PAIRING,
  KIDDO_MEMORY,
  KIDDO_RECOGNIZE,
  KIDDO_RECOGNIZE2,
  KIDDO_DRAGLETTERS,
  KIDDO_WRITING,
  KIDDO_LETTERS,
];

const protectedRoutes = [
  MY_LISTS,
  WORDS_LIST,
  WORDS_LIST_ITEM,
  CATALOG,
  PRIVACY_POLICY,
  TERMS_AND_CONDITIONS,
  CONTACT,
  STUDENTS,
  PROFILE,
  ...gameRoutes,
];

const ProtectedRoutes = (
  <ProtectedRoute exact path={protectedRoutes}>
    <Layout>
      <DefaultLayout>
        <ProtectedRoute exact path={MY_LISTS}>
          <StudentWordsListsView />
        </ProtectedRoute>
        <ProtectedRoute exact path={WORDS_LIST}>
          <WordsListsView />
        </ProtectedRoute>
        <ProtectedRoute exact path={WORDS_LIST_ITEM}>
          <WordsListView />
        </ProtectedRoute>
        <ProtectedRoute exact path={CATALOG}>
          <CatalogEntriesView />
        </ProtectedRoute>
        <ProtectedRoute exact path={PROFILE}>
          <div>PROFILE</div>
        </ProtectedRoute>
        <ProtectedRoute exact path={STUDENTS}>
          <StudentListView />
        </ProtectedRoute>

        <ProtectedRoute exact path={gameRoutes}>
          <ActiveListGuard>
            <ProtectedRoute exact path={LETTERS}>
              <LettersView />
            </ProtectedRoute>
            <ProtectedRoute exact path={REPEAT}>
              <RepeatView />
            </ProtectedRoute>
            <ProtectedRoute exact path={FIND}>
              <FindView />
            </ProtectedRoute>
            <ProtectedRoute exact path={PICK}>
              <PickView />
            </ProtectedRoute>
            <ProtectedRoute exact path={MEMORY}>
              <MemoryView />
            </ProtectedRoute>
            <ProtectedRoute exact path={PAIRING}>
              <PairingView />
            </ProtectedRoute>
            <ProtectedRoute exact path={RECOGNIZE}>
              <RecognizeView />
            </ProtectedRoute>
            <ProtectedRoute exact path={RECOGNIZE2}>
              <RecognizeView2 />
            </ProtectedRoute>
            <ProtectedRoute exact path={WRITING}>
              <WritingView />
            </ProtectedRoute>

            <ProtectedRoute exact path={KIDDO_REPEAT}>
              <KiddoRepeatView />
            </ProtectedRoute>
            <ProtectedRoute exact path={KIDDO_FIND}>
              <KiddoFindView />
            </ProtectedRoute>
            <ProtectedRoute exact path={KIDDO_PICK}>
              <KiddoPickView />
            </ProtectedRoute>
            <ProtectedRoute exact path={KIDDO_PAIRING}>
              <KiddoPairingView />
            </ProtectedRoute>
            <ProtectedRoute exact path={KIDDO_MEMORY}>
              <KiddoMemoryView />
            </ProtectedRoute>
            <ProtectedRoute exact path={KIDDO_RECOGNIZE}>
              <KiddoRecognizeView />
            </ProtectedRoute>
            <ProtectedRoute exact path={KIDDO_RECOGNIZE2}>
              <KiddoRecognizeView2 />
            </ProtectedRoute>
            <ProtectedRoute exact path={KIDDO_DRAGLETTERS}>
              <KiddoDragLettersView />
            </ProtectedRoute>
            <ProtectedRoute exact path={KIDDO_WRITING}>
              <KiddoWritingView />
            </ProtectedRoute>
            <ProtectedRoute exact path={KIDDO_LETTERS}>
              <KiddoLettersView />
            </ProtectedRoute>
          </ActiveListGuard>
        </ProtectedRoute>

        <ProtectedRoute exact path={PRIVACY_POLICY}>
          <PrivacyPolicyView />
        </ProtectedRoute>
        <ProtectedRoute exact path={TERMS_AND_CONDITIONS}>
          <TermsAndConditionsView />
        </ProtectedRoute>
        <ProtectedRoute exact path={CONTACT}>
          <ContactView />
        </ProtectedRoute>
      </DefaultLayout>
    </Layout>
  </ProtectedRoute>
);

export default ProtectedRoutes;
